import { Box, Typography } from '@mui/material';

export const InvoicesPage = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Invoices Management
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Invoices management interface will be implemented here. This will include viewing, creating,
        editing, and managing invoice data.
      </Typography>
    </Box>
  );
};
